import React from 'react'
import { bem } from '@argos/utils'
import { InformationIcon } from '@argos/icons'
import filesize from 'filesize'

const cn = bem({ prefix: 'lc-', block: 'message-file-transfer' })

export const MessageFileTransfer = ({ text, className, fileInfo }) => (
  <div className={`${className('body')} ${cn()}`}>
    <div className={cn('icon')}>
      <InformationIcon fill='#8f908f' width={30} height={30} />
    </div>
    <a className={`${className('url')} ${cn('link')} button-link`} href={fileInfo.address} target='_blank'>
      {text} ({filesize(fileInfo.size)})
    </a>
  </div>
)

export default MessageFileTransfer
